import { useState } from "react";

import { PaginationMeta } from "./usePagination";

type UseLocalPaginationReturnProps = {
  localPagination: PaginationMeta;
  setLocalPagination: React.Dispatch<React.SetStateAction<PaginationMeta>>;
  paginationQuery: string;
};

const getLocalPagination = (
  paginationData: PaginationMeta | undefined,
): string => {
  if (!paginationData) {
    return "";
  }

  const formattedPagination = Object.entries(paginationData)
    .filter(([key]) => key !== "totalPages" && key !== "totalResult")
    .map(([key, value]) => {
      if (typeof value === "string") {
        return `${key}=${value}`;
      }
      const numericValue = Number(value);

      return Number.isFinite(numericValue) ? `${key}=${numericValue}` : null;
    })
    .filter(Boolean) // Remove any null values
    .join("&");

  return formattedPagination ? `&${formattedPagination}` : "";
};

const useLocalPaginationHelper = (): UseLocalPaginationReturnProps => {
  const [localPagination, setLocalPagination] = useState<PaginationMeta>({
    limit: 10,
    offset: 0,
    currentPage: 1,
  });

  const paginationQuery = getLocalPagination(localPagination);

  return {
    localPagination,
    setLocalPagination,
    paginationQuery,
  };
};

export default useLocalPaginationHelper;
